import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const CashFlowPage = lazyImport(() => import('~/views/cash/CashFlowPage'));
const CategoriesPage = lazyImport(() => import('~/views/categories/CategoriesPage'));

export const cashflowRoutes: RouteObject[] = [
  {
    index: true,
    element: <CashFlowPage />,
  },
  {
    path: 'categories',
    element: <CategoriesPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Cashflow.buildLink()} replace />,
  },
];
